// Constants for different requests for current reducer
export default {
  tsByMobilePatrol: 'TS_BY_MOBILE_PATROL',
};
